import React from 'react';
import { classNames, durationToSeconds } from '../../../../Services/helpers';
import { statuses } from '../../../../Data/Jobs';

// Write these out so they're not stripped from the CSS
const widths = ['w-2', 'w-3', 'w-4', 'w-5', 'w-6', 'w-7', 'w-8', 'w-9', 'w-10', 'w-11', 'w-12'];

const JobDot = ({job, compact}) => {

    const fifteenMins = job.duration ? Math.max(0, Math.floor(durationToSeconds(job.duration) / 900) - 1) : 0;

    return <div className={classNames(
        'rounded-full',
        compact ? 'h-[0.2rem]' : 'h-1',
        statuses[job.status]?.bgColor ?? 'bg-black',
        // Go a bit wider on the compact view
        widths[compact ? fifteenMins + 1 : fifteenMins] ?? 'w-14'
    )} />

}

export default JobDot;